import React, { useEffect, useState } from 'react'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import { useChats } from '../../Hook/App';
import { Link } from 'react-router-dom';
import { useChat } from '../../Hook/Chat';
function Index() {
    const [tab, setTab] = useState("all");
    const { rooms, user, connected } = useChat()
   

    const Room = ({ room }) => {
        return (
            <Link to={"/Chat?id=" + room.room_sessionid} className="item my-3 d-block" style={{ borderRadius: 10 }}>
                <div className="d-flex">
                    <a style={{ textDecoration: "none" }}>
                        <div className="item-img">
                            <img src={room.item && room.item.images[0]} />
                        </div>
                    </a>
                    <div className="item-info">
                        <div className="d-flex justify-content-between">
                            <p>{room.room_title}</p>

                        </div>
                        <div className="d-flex">
                            <span>{room.message}</span>
                        </div>
                        <div className='mt-2 d-flex justify-content-between'>
                            <span>{new Date(room.time).toLocaleDateString('fa')}</span>
                        </div>
                    </div>
                </div>
            </Link>
        )
    }


    const Render = () => {

        switch (tab) {
            case 'all':
                return rooms.map((room, i) => {
                    return (
                        <Room key={i} room={room} />
                    )
                })

            case 'buy':
                return rooms.filter((rm) => rm.item && rm.item.user_id != user.id).map((room, i) => {
                    return (
                        <Room key={i} room={room} />
                    )
                })
            case 'sale':
                return rooms.filter((rm) => rm.item && rm.item.user_id == user.id).map((room, i) => {
                    return (
                        <Room key={i} room={room} />
                    )
                })
            default:

                return null;
        }

    }


    return (
        <Layout>
            <HeaderMain lable={connected ? "گفتگوها" : "درحال اتصال ..."} />
            <div className="messages-main">
                <div className="tab my-3">
                    <div className="row">
                        <div className="col-4 bborder" style={tab == "all" ? { borderBottomColor: "#2185e2" } : { border: "none" }}>
                            <button className="tab-btn" onClick={() => setTab("all")}>همه چت ها</button>
                        </div>
                        <div className="col-4 bborder" style={tab == "buy" ? { borderBottomColor: "#2185e2" } : { border: "none" }}>
                            <button className="tab-btn" onClick={() => setTab("buy")}>خرید</button>
                        </div>
                        <div className="col-4 bborder" style={tab == "sale" ? { borderBottomColor: "#2185e2" } : { border: "none" }}>
                            <button className="tab-btn" onClick={() => setTab("sale")}>فروش</button>
                        </div>
                    </div>
                </div>
                <div className='px-3'>
                    {rooms && rooms.length ?
                        <Render />
                        :
                        null
                    }

                </div>
            </div>
        </Layout>
    )
}

export default Index